/*
 * Copyright (c) 2021 Adres.
 * All rights reserved.
 */

const styles = theme => ({
  btn: {
    minWidth: 'auto',
    minHeight: 'auto',
    lineHeight: 1,
    fontSize: '16px',
    fontWeight: 600,
    textTransform: 'lowercase',
    borderRadius: 0,
    padding: '17.5px 24px',
    boxShadow: 'none',
    '& .MuiButton-label': {
      display: 'flex',
      alignItems: 'center',
      gap: '8px',
      '& > span::first-letter': {
        textTransform: 'uppercase',
      },
    },
  },

  primaryBtn: {
    backgroundColor: theme.palette.primary.main,
    color: theme.palette.primary.white,
    border: `1px solid ${theme.palette.primary.main}`,
    '&:focus': {
      backgroundColor: theme.palette.primary.main,
      color: theme.palette.primary.white,
    },
    '&:hover': {
      backgroundColor: theme.palette.primary.adgmHover,
      color: theme.palette.primary.white,
    },
  },
  secondaryBtn: {
    backgroundColor: theme.palette.primary.white,
    color: theme.palette.primary.main,
    border: `1px solid ${theme.palette.primary.main}`,
    '&:focus': {
      backgroundColor: theme.palette.primary.adgmHover,
      color: theme.palette.primary.white,
    },
    '&:hover': {
      backgroundColor: theme.palette.primary.adgmHover,
      color: theme.palette.primary.white,
    },
  },
  tertiaryBtn: {
    backgroundColor: theme.palette.primary.white,
    color: theme.palette.primary.adgmBlack,
    border: `1px solid ${theme.palette.primary.adgmBlack}`,
    // '&:focus': {
    //   backgroundColor: theme.palette.primary.adgmHover,
    //   color: theme.palette.primary.white,
    // border: 'none',
    // '& img':{
    //   filter:'invert(1)'
    // }
    // },
    '&:hover': {
      backgroundColor: theme.palette.primary.adgmHover,
      color: theme.palette.primary.white,
      border: 'none',
      '& img': {
        filter: 'invert(1)',
      },
    },
  },
  disabledBtn: {
    backgroundColor: `${theme.palette.primary.black20} !important`,
    color: `${theme.palette.primary.white} !important`,
    borderColor: '#D5D6D7 !important',
    '& img': {
      filter: 'invert(0.3)',
    },
  },
});

export default styles;
